module.exports = __webpack_public_path__ + "img/w3_circle_gridlist_black.3cce02d3.3cce02d3.png";